import {
  GET_RESPONSE_TYPE,
  individualGroupPerformanceConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { brandPerformanceService } from "../../services";
import {
  success,
  withSpinner,
  failure,
} from "../../../../redux/actions/utilities";

const { ALL_GROUP_RESPONSE_DATA, CUSTOMER_RESPONSES_EXPORT_ALL_DATA } =
  individualGroupPerformanceConstants;

const { GET_GROUP_USER_RESPONSES } = GET_RESPONSE_TYPE;

const getAllFranchiseResponsesItemsForExport = (
  createDateFrom,
  createDateTo,
  groupId,
  body,
) => {
  return (dispatch) => {
    withSpinner(dispatch, ALL_GROUP_RESPONSE_DATA, () =>
      brandPerformanceService
        .getRecordPaginationResponses({
          createDateFrom: createDateFrom,
          createDateTo: createDateTo,
          id: groupId,
          type: GET_GROUP_USER_RESPONSES,
          ...body,
        })
        .then(
          (response) => {
            dispatch(
              success(
                response.pageData.result,
                CUSTOMER_RESPONSES_EXPORT_ALL_DATA,
              ),
            );
          },
          (error) => {
            dispatch(resetAllExportItems());
            customToast(error, toastTypes.ERROR);
          },
        )
    );
  };
};

const resetAllExportItems = () => {
  return (dispatch) => {
    dispatch(failure([], CUSTOMER_RESPONSES_EXPORT_ALL_DATA));
  };
};

export const individualGroupPerformanceActions = {
  getAllFranchiseResponsesItemsForExport,
  resetAllExportItems,
};
